module.exports = __webpack_public_path__ + "static/sui-popup-3d66f39c66b5436b16d57b4f2c9a43c0.png";